module.exports = __webpack_public_path__ + "static/media/Anna.26224124.png";